export class DocumentExporterOptions {
    constructor() {
        this.ensurePictureLoadedTimeout = 3000;
    }
}
